import {ConstraintType} from '../../../../../common/apis/datatype/DataTypeConstraintDto';

import {ConstraintValueValidationPlugin} from "./ConstraintValueValidationPlugin";
import {EnumerationConstraintPlugin} from "./enumeration/EnumerationConstraintPlugin";
import {IntegerRangeConstraintPlugin} from "./range/IntegerRangeConstraintPlugin";
import {FloatRangeConstraintPlugin} from "./range/FloatRangeConstraintPlugin";
import {RegExConstraintPlugin} from "./regex/RegExConstraintPlugin";
import {TimeRangeConstraintPlugin} from "./range/TimeRangeConstraintPlugin";
import {CurrencyRangeConstraintPlugin} from "./range/CurrencyRangeConstraintPlugin";
import {DateRangeConstraintPlugin} from "./range/DateRangeConstraintPlugin";
import {DateTimeRangeConstraintPlugin} from "./range/DateTimeRangeConstraintPlugin";

export class ConstraintValueValidationPluginRegistry {
    private static readonly plugins: Map<ConstraintType, ConstraintValueValidationPlugin> = new Map();

    static registerPlugin(plugin: ConstraintValueValidationPlugin): void {
        this.plugins.set(plugin.type, plugin);
    }

    static getPlugin(type: ConstraintType): ConstraintValueValidationPlugin | undefined {
        return this.plugins.get(type);
    }

}

ConstraintValueValidationPluginRegistry.registerPlugin(new EnumerationConstraintPlugin());
ConstraintValueValidationPluginRegistry.registerPlugin(new IntegerRangeConstraintPlugin());
ConstraintValueValidationPluginRegistry.registerPlugin(new FloatRangeConstraintPlugin());
ConstraintValueValidationPluginRegistry.registerPlugin(new RegExConstraintPlugin());
ConstraintValueValidationPluginRegistry.registerPlugin(new TimeRangeConstraintPlugin());
ConstraintValueValidationPluginRegistry.registerPlugin(new CurrencyRangeConstraintPlugin());
ConstraintValueValidationPluginRegistry.registerPlugin(new DateRangeConstraintPlugin());
ConstraintValueValidationPluginRegistry.registerPlugin(new DateTimeRangeConstraintPlugin());